import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import {
  authUserPermissions as Permissions,
  allPermission,
} from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { USERS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_USERS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'users',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "users.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-users-layout',
      render: (h) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "users.list" */
          './UsersList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "users.view" */
          './UsersView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        meta: {
          permission: Permissions.edit,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "users.view" */
          './UsersView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "users.view" */
          './UsersView.vue'
        ),
      },
      {
        path: '/profile',
        name: ROUTES.PROFILE,
        meta: {
          permission: allPermission,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "users.profile" */
          './UsersProfile.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options): RouteConfig[] => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
